import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";

import "@/App.css";
import LandingPage from "@/pages/LandingPage";
import WizardPage from "@/pages/WizardPage";
import ReviewPage from "@/pages/ReviewPage";
import ResultsPage from "@/pages/ResultsPage";
import LoginPage from "@/pages/LoginPage";
import AdminPage from "@/pages/AdminPage";
import MySpecificationsPage from "@/pages/MySpecificationsPage";
import AccountPage from "@/pages/AccountPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import AnnouncementBar from "@/components/AnnouncementBar";
import { WizardProvider } from "@/state/wizard";
import { AuthProvider } from "@/state/auth";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <WizardProvider>
          <BrowserRouter>
            <AnnouncementBar />
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/wizard" element={<ProtectedRoute><WizardPage /></ProtectedRoute>} />
              <Route path="/review" element={<ProtectedRoute><ReviewPage /></ProtectedRoute>} />
              <Route path="/results" element={<ProtectedRoute><ResultsPage /></ProtectedRoute>} />
              <Route path="/my-specifications" element={<ProtectedRoute><MySpecificationsPage /></ProtectedRoute>} />
              <Route path="/account" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
              <Route path="/admin" element={<ProtectedRoute adminOnly><AdminPage /></ProtectedRoute>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#ffffff",
                color: "#1f2937",
                border: "1px solid #e5e7eb",
                borderRadius: "2px",
                fontFamily: "IBM Plex Sans, sans-serif",
              },
            }}
          />
        </WizardProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
